import React from "react";
import styled from "styled-components";

const TitleBox = styled.div`
  padding-bottom: 40px;
`;

const PageTit = styled.strong`
  font-size: 28px;

  &:after {
    display: block;
    width: 80px;
    height: 2px;
    margin-top: 32px;
    background: #118ccf;
    content: "";
  }
`;

const Title = ({ title }) => {
  return (
    <TitleBox>
      <div className="inr">
        <PageTit>{title}</PageTit>
        {/* <ul className="breadcrumb">
          <li>Home</li>
          <li>연구정보</li>
          <li>임상시험 모집정보</li>
        </ul> */}
      </div>
    </TitleBox>
  );
};

export default Title;
